/**
 * Public read for egd-games live preview (no drafts on this collection).
 *
 * @param {import('@payloadcms/live-preview').CollectionPopulationRequestHandlerArgs} args
 */
export async function egdLivePreviewRequestHandler({ apiPath, data, serverURL }) {
  const incoming = data?.data;
  const docId = incoming?.id;

  if (!docId) {
    return new Response(JSON.stringify(incoming ?? {}), {
      status: 200,
      headers: { "Content-Type": "application/json" },
    });
  }

  const url = `${serverURL}${apiPath}/egd-games/${docId}?depth=1`;
  const response = await fetch(url, {
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "X-Payload-HTTP-Method-Override": "GET",
    },
    method: "POST",
  });

  if (!response.ok) return response;

  let doc;
  try {
    doc = await response.json();
  } catch {
    return response;
  }

  // Payload may return relation IDs for imageMedia; hydrate once for reliable preview paths.
  if (doc && (typeof doc.imageMedia === "number" || typeof doc.imageMedia === "string")) {
    const mediaId = String(doc.imageMedia).trim();
    if (mediaId) {
      try {
        const mediaResponse = await fetch(`${serverURL}${apiPath}/media/${mediaId}?depth=0`);
        if (mediaResponse.ok) {
          doc.imageMedia = await mediaResponse.json();
        }
      } catch {
        // Keep original doc if media hydration fails.
      }
    }
  }

  return new Response(JSON.stringify(doc), {
    status: 200,
    headers: { "Content-Type": "application/json" },
  });
}
